import useDefinedContext from "@entrilia/shared/hooks/useDefinedContext";
import ImpersonationBlockContext from "./ImpersonationBlockContext";

const useImpersonationBlockContext = () => useDefinedContext(ImpersonationBlockContext, "ImpersonationBlockContext");

export default useImpersonationBlockContext;
